export const ENV = {
  // REACT_APP_BASE_URL: 'https://kastafiore-api-oxygen.vo2-group.com',
  REACT_APP_BASE_URL: 'https://kastafioreapi.etude-tabapsy.fr',
  REACT_APP_BASE_URL_MOCK: 'https://ebc36566-93e2-4300-b2ec-9a353debbbe7.mock.pstmn.io',
  RESONANCE_BASE_URL: 'https://app.etude-tabapsy.fr'
};
